import React from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { formValueSelector, registerField } from 'redux-form'
import { useMount } from 'react-nb-hooks'
import mapValues from 'lodash/mapValues'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { withTwilight } from 'loankeeper-common/components/hocs/Twilight'

import {
  loadCustomFieldsIfNeeded,
  isLoadingCustomFields,
  getCustomFieldsByCacheKey,
  customFieldsAttributesToString,
} from '../../store/customFields'
import { LoadingIndicator } from '../shared/LoadingIndicator'
import CustomFieldsForm from './CustomFieldsForm'
import { getDynamicOptions } from './selectors'
import { formattedDate } from './helpers'

const CustomFields = ({
  form,
  initialValues,
  editing,
  prefix,
  onSubmit,
  hidden,
  endTwilight,
  startTwilight,
  type,
  selfInitializeForm,
  subType,
  productId,
  collateralType,
  clientType,
}) => {
  const attributes = {
    groupId: type,
    subGroupId: subType,
    productId,
    collateralType,
    clientType,
  }

  const cacheKey = React.useMemo(() => customFieldsAttributesToString(attributes), [attributes])

  const dispatch = useDispatch()

  const fields = useSelector((state) => getCustomFieldsByCacheKey(state, cacheKey)) || []
  const dynamicOptions = useSelector((state) => getDynamicOptions(state, fields, formValueSelector(form)), shallowEqual)

  const isLoading = useSelector(isLoadingCustomFields)

  useMount(() => {
    async function loadData() {
      if (typeof endTwilight === 'function') {
        startTwilight()
      }

      await dispatch(
        loadCustomFieldsIfNeeded({
          cacheKey,
          groupId: type,
          subGroupId: subType,
          productId,
          collateralType,
          clientType,
        }),
      )

      if (typeof endTwilight === 'function') {
        endTwilight()
      }
    }

    loadData()
  })

  const regField = React.useCallback((name) => dispatch(registerField(form, name, 'Field')), [dispatch, form])

  const transformed = React.useMemo(() => {
    if (!initialValues) {
      return {}
    }

    return mapValues(initialValues, (value) => (LKDate.isValidFormat(value) ? formattedDate(value) : value))
  }, [initialValues])

  if (isLoading) {
    return <LoadingIndicator />
  }

  return (
    <CustomFieldsForm
      // @ts-ignore
      hidden={hidden}
      fields={fields}
      prefix={prefix}
      form={form}
      editing={editing}
      initialValues={transformed}
      dynamicOptions={dynamicOptions}
      onSubmit={onSubmit}
      regField={regField}
      selfInitializeForm={selfInitializeForm}
    />
  )
}

CustomFields.defaultProps = {
  subType: 1,
  editing: false,
  prefix: '',
  onLoad: () => {},
}

export default withTwilight(CustomFields)
